<template>
  <Can action="store" subject="banner">
    <div data-component-group="banner-dialog" data-component="add-new">
      <dialog-add
        icon="picture_in_picture"
        :title="$t('create_banner')"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-banner-add-new
            :banner="{}"
            class="elevation-1"
            :is-loading="isAddingBanner"
            :on-cancel="onCancel"
            :on-submit="createBanner"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        isAddingBanner: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'site-messages' });
      },
      createBanner(banner) {
        this.isAddingBanner = true;

        return this.$store
          .dispatch('siteMessages/create', banner)
          .then((res) => {
            this.$router.push({ name: 'site-messages', query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingBanner = false;
          });
      },
    },
  };
</script>
